module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('/assets/remoteEntry.js?t=1770949331910');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;